export const s3bucket = "https://bytesbrick.s3.ap-south-1.amazonaws.com";
export const apiBaseURL = "https://stage.cms.api.clarionaudio.com/v1";
export const defaultPage = {
    total: 1,
    totalPages: 1,
    current_page: 1,
    perPage: 100,
    nextPage: null,
    previousPage: null
}